import { EldmlTransform } from "./EldmlTransform";
import $ from "jquery";

export class GroupTransform extends EldmlTransform {
  apply() {
    if (!this.transformer.mobile) {
      return;
    }

    this.selector.find("group").each((_: any, element: Element) => {
      const group = $(element);
      const code = group.attr("code");
      if (code) {
        group.on("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.transformer.onGroupClick?.(code);
        });
      }
    });
  }
}
